import { render, staticRenderFns } from "./FeesMethodology.vue?vue&type=template&id=df98425e&scoped=true&"
import script from "./FeesMethodology.vue?vue&type=script&lang=js&"
export * from "./FeesMethodology.vue?vue&type=script&lang=js&"
import style0 from "./FeesMethodology.vue?vue&type=style&index=0&id=df98425e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df98425e",
  null
  
)

export default component.exports